<template>
    <div v-if="savePage">
        <CkNewSaveSusses v-if="saveSuccess"/>
        <CkNewUpdateDetails
            v-else
            :on-save-update="onSave"
        />
    </div>
</template>

<script>
    import CkNewUpdateDetails from './CkNewUpdateDetails'
    import CkNewSaveSusses from './CkNewSaveSusses'
    import gaTrackerAdapter from '../utils/gaTrackerAdapter'
    import * as AbTestFlag from '../utils/abTestingUtil'

    export default {
        name: 'CreativeKids',
        components: { CkNewUpdateDetails, CkNewSaveSusses },
        props: {
            tuoClient: {
                type: Object,
                default: () => ({})
            },
            savePage: {
                type: Boolean
            },
        },
        data: () => ({
            saveSuccess: undefined,
            creativeKids: window.location.href.includes('creative-kids'),
        }),
        async created() {
            const agreeToSave = window.sessionStorage.getItem('tuoAgreeToSave') === 'Yes'
            if(this.savePage) {
                gaTrackerAdapter.trackEvent(
                    'Load Component',
                    'CkNewOfferedToStoreUpdatedDetails',
                    window.location.href)
            } else if (agreeToSave) {
                const updatedDetails = await this.tuoClient.getCustomerUpdate()
                let detailsToSave = []
                const updatedDetailsRemoveIdDoc = updatedDetails.filter( item => item['name'] !== 'medicare' && item['name'] !== 'driverLicence')

                updatedDetailsRemoveIdDoc.forEach(detail => detailsToSave.push(detail.name))

                this.tuoClient.saveCustomerUpdate(detailsToSave)
                window.sessionStorage.removeItem('tuoAgreeToSave')
                AbTestFlag.clean()
            }
        },
        methods: {
            onSave() {
                const firstSave = window.sessionStorage.getItem('tuoAgreeToSave') !== 'Yes'
                if (firstSave) {
                    gaTrackerAdapter.trackEvent(
                        'Save',
                        'CkNewAgreedToStoreUpdatedDetails',
                        window.location.href,
                        {dimension1: true}
                    )
                    window.sessionStorage.setItem('tuoAgreeToSave', 'Yes')
                }

                const dataToSave = window.sessionStorage.getItem('tuoCurrentData')
                window.sessionStorage.setItem('tuoSavedData', dataToSave)
                this.saveSuccess = true
            }
        }
    }
</script>
